import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { getSoftGroupCatalogListSync } from '@/utils/soft-group-catalog'

export interface QueryParams {
  key_word: string // 关键词
  page: number // 页码
  limit: number // 每页数量
  sort?: string // 排序字段
  asc?: boolean // 顺序
  group_id: number // 分组id
  /** 软件类型（与静态 softGroupCatalog 的 group_id 对应） */
  soft_type?: number | string
}

export interface SoftGroupItem {
  group_id: number
  group_name: string
  group_desc?: string
}

export interface SoftwareInfo {
  name: string // 软件名
  install_count: number // 下载终端数
  install_rate: number // 安装率
  soft_type: number // 软件类型
  soft_id: number // 软件id
  max_version: string // 最大版本
  min_version: string // 最小版本
  display_name: string // 卸载注册表里的dispalyname
}

export interface ResponseData {
  list: SoftwareInfo[] // 软件列表
  total: number // 总数
}

@Injectable()
export class SoftwareManageService {
  constructor (private http: Http) {}

  @ParamsClean()
  @InvokeThrottle()
  getSoftwareList (data: QueryParams) {
    return this.http.post<ResponseData>('/softmgr/soft-stat', data)
  }

  /** 软件分类下拉（与筛选 soft_type 一致，文案来自 i18n） */
  getSoftGroup () {
    return Promise.resolve({ list: getSoftGroupCatalogListSync() })
  }

  download (type: 0|1, options: QueryParams, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/softmgr/soft-stat/export', params, moduleName)
  }
}
